import './css/Portfolio.css';

import { Link } from 'react-router-dom';
import { chunk } from 'lodash';

import architecturalImg from './images/portfolio/thumbnails/architectural.jpg';
import weddingsAndEngagementsImg from './images/portfolio/thumbnails/weddings-and-engagements.jpg';
import churchesSchoolsAndSportsImg from './images/portfolio/thumbnails/churches-schools-and-sports.jpg';
import commercialPhotographyImg from './images/portfolio/thumbnails/commercial-photography.jpg';
import partiesAndEventsImg from './images/portfolio/thumbnails/parties-and-events.jpg';
import familyAndKidsImg from './images/portfolio/thumbnails/family-and-kids.jpg';
import vipsPoliticiansAndBigshotsImg from './images/portfolio/thumbnails/vips-politicians-and-bigshots.jpg';
import portraitsImg from './images/portfolio/thumbnails/portraits.jpg';

const thumbnails = [
                    { "img": architecturalImg, "text": "Architectural", "href": "/architectural" },
                    { "img": weddingsAndEngagementsImg, "text": "Weddings and Engagements", "href": "/weddings-and-engagements" },
                    { "img": churchesSchoolsAndSportsImg, "text": "Churches, Schools, and Sports", "href": "/churches-schools-and-sports" },
                    { "img": commercialPhotographyImg, "text": "Commercial Photography", "href": "/commercial-photography" },
                    { "img": partiesAndEventsImg, "text": "Parties and Events", "href": "/parties-and-events" },
                    { "img": familyAndKidsImg, "text": "Family and Kids", "href": "/family-and-kids" },
                    { "img": vipsPoliticiansAndBigshotsImg, "text": "VIP's, Politicians, and Bigshots", "href": "/vips-politicians-and-bigshots" },
                    { "img": portraitsImg, "text": "Portraits", "href": "/portraits" }
];

function Portfolio() {
    const rows = chunk(thumbnails, 2);
    return (
        <table className="portfolio">
          {
            rows.map((row, rowIndex) => (
              <tr className={(rowIndex === 0 && "header")}>
                {
                  row.map((thumbnail, index) => (
                    <td className={(index % 2 === 0 && "portfolio-left") || "portfolio-right"}>
                      <div className="thumbnail">
                        <Link to={thumbnail.href}><img src={thumbnail.img} alt={thumbnail.text}/></Link>
                      </div>
                      <Link to={thumbnail.href}>{thumbnail.text}</Link>
                    </td>
                  ))
                }
              </tr>
            ))
          }
        </table>
    );
}

export default Portfolio;
